export function Panel({ title, description, action, children, className = "" }) {
  return (
    <section className={`panel ${className}`}>
      {(title || description || action) && (
        <div className="panel-header">
          <div>
            {title && <h2>{title}</h2>}
            {description && <p className="muted">{description}</p>}
          </div>
          {action}
        </div>
      )}
      <div className="panel-body">{children}</div>
    </section>
  );
}

export function StatCard({ label, value, hint }) {
  return (
    <div className="panel stat-card">
      <span>{label}</span>
      <strong>{value}</strong>
      {hint && <p className="muted">{hint}</p>}
    </div>
  );
}

export function EmptyState({ children }) {
  return <p className="muted empty-state">{children}</p>;
}
